export default __webpack_public_path__ + "src/static/img/png/arch-white-section-two-v2.png";